<template lang="pug">
  form(@submit.prevent='submit' novalidate autocomplete='off')
    .row
      p.col.s12.title.medium Add Supplier Shop
    .row
      .input-field.col.s12.m6
        i.material-icons.prefix store
        input#shopName(
          name='name',
          type='text' 
          v-model='shopMutated.name'
          v-validate='validations.name' 
          ref='shopName'
          @keyup='autogenerateCode')
        label(for='shopName') Name
        span.helper-text.red-text(v-if='fields.name && fields.name.touched') {{errors.first('name')}}
      .input-field.col.s12.m6
        i.material-icons.prefix public
        input#shopCode(
          name='code'
          type='text'
          v-model='shopMutated.code'
          v-validate='validations.code'
          data-vv-delay='1000'
          ref='shopCode')
        label(for='shopCode') Web identifier (for url)
        span.helper-text 1-255 Alphanumeric characters (may contain period, underscore, or dash)
        span.helper-text.red-text {{errors.first('code')}}
      .input-field.col.s12
        i.material-icons.prefix location_on
        input-place-autocomplete(
          :name='"location"'
          :id='"shopLocation"' 
          :value='shopMutated.location'
          :source='"google-places"'
          @onLocationAutocomplete='onLocationAutocomplete'
          ref='shopLocation'
          :validation='validations.location')
        label(for='shopLocation') Location
        span.helper-text.red-text(v-if='fields.location && fields.location.touched') {{errors.first('location')}}
    .row
      .col.s12.right-align
        button.btn Save
</template>
<script>
import InputPlaceAutocomplete from '@/components/input-place-autocomplete'

export default {
  props: ['supplierId', 'shop', 'onAddSuccess', 'onAddError'],
  data () {
    return {
      shopMutated: {
        id: null,
        name: null,
        location: null,
        code: null
      },
      shouldValidateLocation: false,
      validations: {
        name: {
          validate: false,
          required: true,
          regex: /^.*[a-zA-Z]+.*$/,
          min: 3,
          max: 255
        },
        code: {
          validate: false,
          required: true,
          regex: /^[a-zA-Z._-]+$/,
          uniqueCode: true
        },
        location: {
          validate: false,
          required: true,
          min: 1,
          max: 255,
          validLocation: true
        }
      }
    }
  },
  created () {
    this.shopMutated = !this.shop
      ? this.shopMutated
      : Object.assign({}, this.shop)

    this.$validator.extend('uniqueCode', {
      getMessage: field => 'The identifier is already taken.',
      validate: this.checkCodeAvailability
    }, {
      immediate: false
    })

    this.$validator.extend('validLocation', {
      getMessage: field => 'Valid location must be selected from the list.',
      validate: this.checkLocationValidity
    }, {
      immediate: false
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.$M.updateTextFields()
    })
  },
  methods: {
    autogenerateCode () {
      this.shopMutated.code = this.shopMutated.name
      ? this.shopMutated.name.toLowerCase().trim().replace(/\s\s*/g, '.')
      : null

      this.$nextTick(() => {
        this.$M.updateTextFields()
      })
    },
    checkCodeAvailability (code) {
      if (!code) {
        return Promise.resolve(true)
      }

      return this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        return this.$http.get(`${this.$config.API_URL}/admin/shops/code/${code}`, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).then(result => {
          return result.data.id === null || result.data.id === this.shopMutated.id
        })
      })
    },
    checkLocationValidity (location) {
      return !!this.shopMutated.location
    },
    submit () {
      this.$validator.validate().then(isValid => {
        if (!isValid) {
          return
        }

        this.$store.dispatch('auth/getAccessToken').then(accessToken => {
          const url = !this.shopMutated.id
          ? `${this.$config.API_URL}/admin/suppliers/${this.supplierId}/shops`
          : `${this.$config.API_URL}/admin/suppliers/${this.supplierId}/shops/${this.shopMutated.id}`
          const method = !this.shopMutated.id
          ? this.$http.post
          : this.$http.put
          const data = {
            name: this.shopMutated.name,
            location: this.shopMutated.location,
            code: this.shopMutated.code
          }
          const options = {
            headers: {
              authorization: `Bearer ${accessToken}`
            }
          }
          return method.apply(this, [url, data, options])
        }).then(result => {
          this.onAddSuccess(result.data)
        }).catch(res => {
          this.onAddError(res)
        })
      })
    },
    onLocationAutocomplete (location) {
      this.shouldValidateLocation = true
      this.shopMutated.location = location
    }
  },
  components: {
    InputPlaceAutocomplete
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal-add-supplier-shop.vue